var map = {
	"./admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"admin-admin-module~user-user-module",
		"common",
		"admin-admin-module"
	],
	"./analytics/analytics.module": [
		"./src/app/pages/analytics/analytics.module.ts",
		"analytics-analytics-module"
	],
	"./components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"components-components-module"
	],
	"./customer/customer.module": [
		"./src/app/pages/customer/customer.module.ts",
		"common",
		"customer-customer-module"
	],
	"./group/group.module": [
		"./src/app/pages/group/group.module.ts",
		"group-group-module"
	],
	"./kiosk/kiosk.module": [
		"./src/app/pages/kiosk/kiosk.module.ts",
		"kiosk-kiosk-module~reporting-reporting-module~transaction-transaction-module",
		"common",
		"kiosk-kiosk-module"
	],
	"./logviewer/logviewer.module": [
		"./src/app/pages/logviewer/logviewer.module.ts",
		"logviewer-logviewer-module"
	],
	"./product/product.module": [
		"./src/app/pages/product/product.module.ts",
		"product-product-module"
	],
	"./reporting/reporting.module": [
		"./src/app/pages/reporting/reporting.module.ts",
		"kiosk-kiosk-module~reporting-reporting-module~transaction-transaction-module",
		"reporting-reporting-module~transaction-transaction-module",
		"app-pages-pages-module~reporting-reporting-module",
		"common",
		"reporting-reporting-module"
	],
	"./template/template.module": [
		"./src/app/pages/template/template.module.ts",
		"template-template-module"
	],
	"./transaction/transaction.module": [
		"./src/app/pages/transaction/transaction.module.ts",
		"kiosk-kiosk-module~reporting-reporting-module~transaction-transaction-module",
		"reporting-reporting-module~transaction-transaction-module",
		"common",
		"transaction-transaction-module"
	],
	"./ui-features/ui-features.module": [
		"./src/app/pages/ui-features/ui-features.module.ts",
		"ui-features-ui-features-module"
	],
	"./user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"admin-admin-module~user-user-module",
		"common",
		"user-user-module"
	],
	"app/pages/authorization/authorization.module": [
		"./src/app/pages/authorization/authorization.module.ts"
	],
	"app/pages/error/error.module": [
		"./src/app/pages/error/error.module.ts",
		"app-pages-error-error-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-pages-module~reporting-reporting-module",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;